import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "./data";

export default function FAQ() {
  const goContact = () => document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="faq" data-testid="faq-section" className="relative py-28 md:py-40">
      <div className="mx-auto max-w-[1440px] px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-4">
          <div className="lg:sticky lg:top-32">
            <span className="font-mono text-xs uppercase tracking-[0.25em] text-muted-foreground">FAQ</span>
            <h2 className="mt-5 font-serif font-light text-4xl sm:text-5xl md:text-6xl tracking-tight leading-none text-foreground">
              The questions we hear most.
            </h2>
          </div>
        </div>

        <div className="lg:col-span-8">
          <Accordion type="single" collapsible className="w-full border-t border-border">
            {FAQS.map((item, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ delay: (i % 4) * 0.05, duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
              >
                <AccordionItem value={`faq-${i}`} className="border-b border-border">
                  <AccordionTrigger
                    data-testid={`faq-question-${i}`}
                    className="py-6 font-serif text-xl md:text-2xl tracking-tight text-foreground hover:no-underline gap-6"
                  >
                    {item.q}
                  </AccordionTrigger>
                  <AccordionContent data-testid={`faq-answer-${i}`} className="pb-8 pr-6 space-y-4">
                    {item.a.map((p, j) => (
                      <p key={j} className="text-sm md:text-base text-muted-foreground leading-relaxed max-w-2xl">
                        {p}
                      </p>
                    ))}
                  </AccordionContent>
                </AccordionItem>
              </motion.div>
            ))}
          </Accordion>

          <div className="mt-10 border border-border bg-secondary p-8 md:p-10" data-testid="faq-still-questions">
            <h3 className="font-serif text-2xl md:text-3xl text-foreground tracking-tight">Still have questions?</h3>
            <p className="mt-3 text-sm md:text-base text-muted-foreground leading-relaxed max-w-2xl">
              Every practice has different enrollment needs, whether you're enrolling your first provider, expanding
              into new payer networks, or organizing an increasingly complex credentialing process, we can help you
              build a clear path forward.
            </p>
            <button
              data-testid="faq-contact-cta"
              onClick={goContact}
              className="mt-6 inline-flex items-center gap-2 rounded-full bg-primary px-6 py-3 text-sm text-primary-foreground transition-transform duration-200 hover:-translate-y-0.5"
            >
              Discuss your needs <ArrowRight size={16} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
